module.exports = __webpack_public_path__ + "static/media/SDG6.f248a068.mp4";